<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { DataField } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditDataField from '@/components/data-fields/EditDataField.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        dataField: DataField;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="dataField">
        <EditDataField :data-field="dataField" />
        <Delete
            v-if="hasPermission(Permission.SYSTEM_DELETE)"
            :route="route('v2.data-fields.destroy', dataField.data_field_id)"
            :query-key="[QueryKey.DATA_FIELDS]"
        />
    </DataTableActions>
</template>
